
import { Component, Vue } from 'vue-property-decorator';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import BusinessHeroLanding from '../components/BusinessHeroLanding.vue';
import BusinessDetails from '../components/BusinessDetails.vue';
import BusinessAwards from '../components/BusinessAwards.vue';
import BusinessOverview from '../components/BusinessOverview.vue';
import BusinessDescription from '../components/BusinessDescription.vue';
import BusinessGallery from '../components/BusinessGallery.vue';
import Business, { BusinessProxy } from '../models/Business';
import DraftBusiness, { DraftBusinessProxy } from '@/models/DraftBusiness';

@Component({
  components: {
    BusinessHeroLanding,
    BusinessDetails,
    BusinessAwards,
    BusinessOverview,
    BusinessDescription,
    BusinessGallery,
  },
})
export default class extends Vue {
  // @Prop(String) readonly slug!: string;

  get isPreview() {
    return this.$route.query.preview === 'true';
  }

  get slug() {
    return this.$route.params.slug;
  }

  get draftId() {
    return parseInt(this.$route.params.slug, 10);
  }

  get dataPromise(): ObservedPromise<BusinessProxy | DraftBusinessProxy> {
    if (this.isPreview) {
      const { draftId } = this;
      const promise = DraftBusiness.includes(['awards', 'awards.image']).find(
        draftId,
      );
      return new ObservedPromise(promise);
    }
    const { slug } = this;
    const promise = Business.includes(['awards', 'awards.image'])
      .where({ slug, isPublic: true })
      .first();
    return new ObservedPromise(promise);
  }

  get business(): Business | DraftBusiness | undefined {
    return this.dataPromise.value?.data || undefined;
  }
}
